if (!customElements.get('journal-454')) {
  customElements.define('journal-454', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.abort = new AbortController();
      const opts = { signal: this.abort.signal };
      this.classList.add('is-enhanced');
      const topicDialog = this.querySelector('.j454-topic-dialog');
      const topicButton = this.querySelector('[data-topics-open]');
      if (topicDialog && topicButton) {
        topicButton.hidden = false;
        topicButton.addEventListener('click', () => topicDialog.showModal(), opts);
        this.querySelector('[data-topics-close]').addEventListener('click', () => topicDialog.close(), opts);
        topicDialog.addEventListener('click', e => { if (e.target === topicDialog) { const r = topicDialog.getBoundingClientRect(); if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) topicDialog.close(); } }, opts);
      }
      this.addEventListener('click', e => {
        const jump = e.target.closest('.j454-toc a,.j454-mobile-shop');
        if (jump?.hash) {
          const target = document.getElementById(decodeURIComponent(jump.hash.slice(1)));
          if (target) { e.preventDefault(); target.scrollIntoView({ behavior:matchMedia('(prefers-reduced-motion:reduce)').matches ? 'auto' : 'smooth', block:'start' }); target.setAttribute('tabindex','-1'); target.focus({preventScroll:true}); }
        }
        const product = e.target.closest('[data-journal-product]');
        const collection = e.target.closest('[data-journal-collection]');
        const contact = e.target.closest('[data-journal-contact]');
        if (product || collection || contact) {
          const link = product || collection || contact;
          this.track(product ? 'blog_product_click' : collection ? 'blog_collection_click' : 'blog_contact_click', { item_handle: product?.dataset.journalProduct || collection?.dataset.journalCollection || '', placement: link.closest('[data-placement]')?.dataset.placement || 'article_contact' });
        }
      }, opts);
      const body = this.querySelector('[data-article-body]');
      if (!body) return;
      this.querySelectorAll('.j454-comments').forEach(el => { if (el.querySelector('[role="alert"], [role="status"]') || location.hash.includes('comment')) el.open = true; });
      body.querySelectorAll('table').forEach(table => { const wrapper = document.createElement('div'); wrapper.className = 'j454-table-scroll'; wrapper.tabIndex = 0; table.before(wrapper); wrapper.append(table); });
      body.querySelectorAll('img').forEach(img => { img.loading = 'lazy'; img.decoding = 'async'; });
      const h2 = [...body.querySelectorAll('h2')];
      const headings = h2.length > 1 ? h2 : [...body.querySelectorAll('h2,h3')];
      const toc = this.querySelector('[data-toc]');
      const list = this.querySelector('[data-toc-list]');
      const usedIds = new Set([...document.querySelectorAll('[id]')].map(el => el.id));
      headings.forEach((heading, i) => {
        if (!heading.id) { let id = `read-${heading.textContent.trim().toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '').slice(0,70) || i}`; while (usedIds.has(id)) id += `-${i}`; heading.id = id; usedIds.add(id); }
        const li = document.createElement('li');
        const a = document.createElement('a');
        a.href = `#${encodeURIComponent(heading.id)}`;
        a.textContent = heading.textContent.trim();
        li.append(a); list?.append(li);
      });
      if (toc && headings.length > 1) { toc.hidden = false; toc.open = !matchMedia('(max-width:989px)').matches; }
      const inlineCta = this.querySelector('[data-inline-cta]');
      if (inlineCta && headings.length > 2) {
        let anchor = headings[Math.min(3, headings.length - 1)];
        while (anchor.parentElement && anchor.parentElement !== body) anchor = anchor.parentElement;
        if (anchor !== body && anchor.parentElement === body) anchor.before(inlineCta);
      }
      const copyButton = this.querySelector('[data-copy-link]');
      if (copyButton && navigator.clipboard) {
        copyButton.hidden = false;
        copyButton.addEventListener('click', async () => {
          const url = new URL(document.baseURI); url.search = ''; url.hash = '';
          try { await navigator.clipboard.writeText(url.href); this.querySelector('[data-copy-status]').textContent = copyButton.dataset.copied; }
          catch { this.querySelector('[data-copy-status]').textContent = copyButton.dataset.copyFailed; }
        }, opts);
      }
      const bar = this.querySelector('.j454-progress');
      if (bar) bar.hidden = false;
      const supplies = this.querySelector('.j454-bottom-supplies');
      const sourceLink = supplies?.querySelector('.j454-collection-link');
      if (sourceLink) {
        const mobileLink = document.createElement('a');
        mobileLink.className = 'j454-button j454-mobile-shop';
        mobileLink.href = `#${supplies.id}`;
        mobileLink.textContent = sourceLink.textContent.trim();
        const arrow = document.createElement('span'); arrow.className = 'j454-arrow'; arrow.innerHTML = '<svg class="icon454-arrow" width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false"><path d="M12 5v14m-6-6 6 6 6-6" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/></svg>'; arrow.setAttribute('aria-hidden','true'); mobileLink.append(arrow);
        mobileLink.hidden = true; this.append(mobileLink); this.mobileLink = mobileLink;
      }
      const reached = new Set();
      let scheduled = false;
      const update = () => {
        scheduled = false;
        const bounds = body.getBoundingClientRect();
        const total = Math.max(1, bounds.height - innerHeight * .4);
        const pct = Math.min(100, Math.max(0, Math.round((100 - bounds.top) / total * 100)));
        if (bar) { bar.querySelector('span').style.transform = `scaleX(${pct / 100})`; bar.setAttribute('aria-valuenow', String(pct)); }
        let current = headings[0];
        for (const heading of headings) if (heading.getBoundingClientRect().top <= 150) current = heading;
        list?.querySelectorAll('a').forEach(a => { if (current && decodeURIComponent(a.hash.slice(1)) === current.id) a.setAttribute('aria-current','location'); else a.removeAttribute('aria-current'); });
        if (this.mobileLink) this.mobileLink.hidden = bounds.top > -250 || supplies.getBoundingClientRect().top < innerHeight + 30;
        [50,90].forEach(depth => { if (pct >= depth && !reached.has(depth)) { reached.add(depth); this.track('blog_read_depth', { percent: depth }); } });
      };
      const schedule = () => { if (!scheduled) { scheduled = true; requestAnimationFrame(update); } };
      window.addEventListener('scroll', schedule, { ...opts, passive:true });
      window.addEventListener('resize', schedule, opts);
      update();
    }
    track(event, details) {
      const privacy = window.Shopify?.customerPrivacy;
      if (privacy && !privacy.analyticsProcessingAllowed()) return;
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event, blog_handle:this.dataset.blog || '', article_handle:this.dataset.article || '', ...details });
    }
    disconnectedCallback() { this.abort?.abort(); }
  });
}

